import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-text-inner-html',
  templateUrl: './text-inner-html.component.html',
  styleUrls: ['./text-inner-html.component.scss'],
})
export class TextInnerHTMLComponent implements OnInit {
  @Input() content: any = `text`;
  @Input() textClasses: String = '';
  constructor() {}

  ngOnInit(): void {}
}
